import { render, staticRenderFns } from "./Ginojisshusei.vue?vue&type=template&id=8d50fcde&scoped=true"
import script from "./Ginojisshusei.vue?vue&type=script&lang=js"
export * from "./Ginojisshusei.vue?vue&type=script&lang=js"
import style0 from "./Ginojisshusei.vue?vue&type=style&index=0&id=8d50fcde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d50fcde",
  null
  
)

export default component.exports